<template>
  <div>
    <div class="expand" :class="{ 'small-menu': !toggle }">
      <span class="material-icons" @click="toggle = !toggle">menu</span>
    </div>
    <div v-show="toggle">
      <div class="bg-menu"></div>
      <div class="menu">
        <MenuItem
          v-for="(item, index) in menuTree"
          :key="index"
          :data="item.children"
          :label="item.label"
          :depth="0"
          :smallMenu="smallMenu"
          :route="item.route"
          @click="close()"
        />
      </div>
      <div class="bg-bottom border-top">
        <i class="bi bi-person"></i>
        <span>Hi, {{ authenticationStore.profile_name }}</span>
        <span
          v-if="
            authenticationStore.role == 'Super Admin' ||
            authenticationStore.role == 'Administrator'
          "
        >
          ({{ authenticationStore.role }})</span
        >
        <span v-else>
          ({{ authenticationStore.department }},
          {{ authenticationStore.role }})</span
        >
        <i class="bi bi-gear"></i><span>Isolated Zone</span>
        <i
          class="bi bi-box-arrow-right"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#logoutModal"
        ></i
        ><span
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#logoutModal"
          >Logout</span
        >
      </div>
      <div class="bg-overlay" @click="toggle = !toggle"></div>
    </div>
  </div>
</template>

<script setup>
import MenuItem from "./MenuItem.vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { useMenuStore } from "@/stores/menu";
import { ref, watch } from "vue";

const authenticationStore = useAuthenticationStore();
const menuStore = useMenuStore();
const smallMenu = ref(false);
const toggle = ref(false);
const menuTree = ref([]);

watch(
  () => authenticationStore.userRole,
  (update) => {
    if (update == 0 || update == 2 || update == 3 || update == 5) {
      menuTree.value = [
        {
          label: "Content Review",
          route: "content",
        },
        {
          label: "Manage Transfers",
          children: [
            {
              label: "Download Reports",
              route: "downloadreport",
            },
            {
              label: "Download DIPs",
              route: "downloaddips",
            },
          ],
        },
        {
          label: "Manage Reports",
          children: [
            {
              label: "Report: Batches Processed",
              route: "batchesprocessed",
            },
          ],
        },
      ];
    } else if (update == 1) {
      menuTree.value = [];
    }
  }
);

const close = () => {
  if (menuStore.isClicked) {
    toggle.value = !toggle.value;
  }
};
</script>

<style lang="scss">
.menu {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background: white;
  z-index: 9;
  position: fixed;
  height: 100vh;
  width: 27%;
  left: 110;
  top: 0;
  border-right: 1px solid #ececec;
  overflow: auto;
  padding-top: 50px;
  padding-bottom: 50px;
}
.expand {
  z-index: 11;
  position: fixed;
  left: 20px;
  font-size: 20px;
  top: 15px;
  user-select: none;
  cursor: pointer;
  transition: all 0.3s ease;
  &.small-menu {
    overflow: inherit;
    width: 60px;
    left: 20px;
  }
}
.bg-menu {
  background: white;
  z-index: 10;
  position: fixed;
  height: 20px;
  width: 25.55%;
  left: 110;
  top: 0;
  overflow: none;
  padding-top: 50px;
}
.bg-bottom {
  background: white;
  z-index: 10;
  position: fixed;
  height: 50px;
  width: 25.55%;
  left: 110;
  bottom: 0;
  padding: 20px;
  padding-top: 10px;
}
.bi {
  font-size: 20px;
  &.bi-person {
    padding-left: 4px;
    padding-right: 4px;
  }
  &.bi-box-arrow-right {
    padding-left: 4px;
    padding-right: 4px;
  }
  &.bi-gear {
    padding-left: 4px;
    padding-right: 4px;
  }
}
.bg-overlay {
  z-index: 5;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  opacity: 60%;
  left: 26%;
  position: fixed;
  overflow: auto;
  width: 74%;
  background: black;
  height: 100vh;
}
</style>
